__webpack_require__.p = "/web3/aidol2025/_next/";